import React, {useState, useEffect} from 'react';
import './cardContable.css';
import { obtenerDatosSeleccionados, obtenerDatosSeleccionadosDisciplina } from '../../methods/methods';

const CardArmonizacion = ({ selectedItemIndex, dataType }) => {
  const [data, setData] = useState([]);

  useEffect(() => {
    if (dataType === "/Recursos") {
      setData(obtenerDatosSeleccionados(selectedItemIndex));
    } else {
      setData(obtenerDatosSeleccionadosDisciplina(selectedItemIndex));
    }
  }, [selectedItemIndex, dataType]);
  return (
    <div className='container'>
      <div className='row card-content-anio'>
          {
            data.map((item, index) => (
                <div key={index} className='col-sm-12 col-12'>
                  <h5>{item.anio}</h5>
                  <div className='card-body card'>
                    
                    {
                      item.trimestre.map((trimestre, index2) => (
                        <div key={index2} className='card_trimestre'>
                          <p>{trimestre.trimestreNombre}
                            <p>{trimestre.trimestreNombre1}</p>
                                                   
                          {
                            trimestre.trimestreContenido.map((contenido) => (
                              <div>
                                {
                                  contenido.excel ?
                                    <span className='badge bg-secondary span-excel'>
                                      <a href={contenido.excel} target="_blank">Excel</a>
                                    </span> : null
                                }
                                {
                                  contenido.pdf ?
                                    <span className='badge bg-secondary span-pdf'>
                                      <a href={contenido.pdf} target="_blank" >PDF</a>
                                    </span> : null
                                }
                              </div>
                            ))
                          }
                          </p>
                        </div>
                      ))
                    }
                  </div>
                </div>
            ))
          }
      </div>
    </div>
  );
}

export default CardArmonizacion;
